import React, { useCallback } from "react";
import * as ReactDOMClient from 'react-dom/client';
import { useJoinCommunity } from "./useJoinCommunity";
const JoinCommunity = () => {
    const { setPassword, pageStatus, communityList, errorMessages, communityPage, submitJoinRequest, collectInvitationCode, removeMyselfFromCommunity, } = useJoinCommunity();
    const renderErrorMessages = useCallback(() => {
        if (pageStatus === "error" || errorMessages.length > 0) {
            return errorMessages.map((message, index) => (React.createElement("small", { key: index, className: "danger mt-2" }, message)));
        }
        if (pageStatus === 'success' && communityPage.communityName) {
            return React.createElement("small", { className: "dark-grey" },
                "You are about to join: ",
                React.createElement("span", { className: "success" }, communityPage.communityName));
        }
        return React.createElement("small", { className: "dark-grey" }, "Please enter your community invitation code to begin the join process.");
    }, [pageStatus, communityPage.communityName, errorMessages]);
    const renderSubmitButton = useCallback(() => {
        return (React.createElement("div", { className: "col-12 col-md-12 d-flex justify-content-left align-self-md-start mt-2" },
            React.createElement("a", { href: "#", className: "small-btn-primary", onClick: submitJoinRequest }, "JOIN COMMUNITY")));
    }, [submitJoinRequest]);
    const renderPasswordField = useCallback(() => {
        if (communityPage.communityValid && communityPage.communityPrivate) {
            return (React.createElement("div", { className: "col-12 col-md-10 mb-3" },
                React.createElement("label", { htmlFor: "community_password" }, "Password"),
                React.createElement("input", { className: "form-control", type: "text", name: "community_password", placeholder: "Enter password..", onChange: e => { setPassword(e.target.value); } })));
        }
        return React.createElement(React.Fragment, null);
    }, [communityPage.communityValid, communityPage.communityPrivate, communityPage.localPassword, setPassword]);
    const renderCommunitiesList = useCallback(() => {
        if (communityList) {
            return (React.createElement("div", { className: 'my-comm d-block col-12' }, communityList.map(({ id, name }, key) => {
                return (React.createElement("div", { key: key, className: 'community-leave-trigger mx-2' },
                    name,
                    React.createElement("span", { className: 'danger', onClick: () => { removeMyselfFromCommunity(parseInt(id)); } }, " x ")));
            })));
        }
        return React.createElement(React.Fragment, null);
    }, [communityList, removeMyselfFromCommunity]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "row" },
            React.createElement("div", { className: "col" },
                React.createElement("h4", null, "My Communities"),
                React.createElement("div", { className: "col-12 col-md-10 mb-3" }, renderCommunitiesList()))),
        React.createElement("div", { className: "row pb-4 pt-4", style: { background: '#ececec' } },
            React.createElement("h4", null, "Join a Community"),
            React.createElement("div", { className: "col-12 col-md-10" },
                React.createElement("div", { className: "mb-1", style: { minHeight: 50 } }, renderErrorMessages()),
                React.createElement("div", { className: "col-12 col-md-10 mb-2" },
                    React.createElement("label", { htmlFor: "community_invitation_code" }, "Invitation Code"),
                    React.createElement("input", { className: "form-control", type: "text", name: "community_invitation_code", placeholder: "Enter invitation code..", value: communityPage.invitationCode, onChange: e => collectInvitationCode(e.target.value) })),
                renderPasswordField()),
            renderSubmitButton())));
};
const rctJoinCommunity = document.getElementById("rct-join-community");
if (rctJoinCommunity !== null) {
    ReactDOMClient.createRoot(rctJoinCommunity).render(React.createElement(JoinCommunity, null));
}
